import { useLocale } from '@/providers/LocaleProvider';
import AddIcon from '@/resources/images/icons-add.svg';
import { KLAYO_COLORS } from '@/themes';
import { Box, Stack, Typography } from '@mui/material';
import { forwardRef, useImperativeHandle } from 'react';
import { JobBuilderSectionRef } from './jobBuilder.types';

interface Props {}

export const JobBuilderScratchSection = forwardRef<JobBuilderSectionRef, Props>((_props, ref) => {
  useImperativeHandle(ref, () => ({
    submit: () => Promise.resolve(''),
  }));

  const { translate } = useLocale();

  return (
    <Stack alignItems='center' justifyContent='center' gap={2} sx={{ flex: 1, height: '100%' }}>
      <Box
        sx={{
          '& svg path[fill="#111827"]': {
            fill: KLAYO_COLORS.NeonBlueNB100,
          },
        }}
      >
        <AddIcon width={40} height={40} />
      </Box>
      <Stack alignItems='center' gap={1}>
        <Typography variant='body1' fontWeight={600} color={KLAYO_COLORS.GreyGR900}>
          {translate('jobBuilder.startFromScratch')}
        </Typography>
        <Typography
          variant='body2'
          color={KLAYO_COLORS.GreyGR500}
          textAlign='center'
          sx={{ maxWidth: 360 }}
        >
          {translate('jobBuilder.startFromScratchDescription')}
        </Typography>
      </Stack>
    </Stack>
  );
});

JobBuilderScratchSection.displayName = 'JobBuilderScratchSection';
